import { MenuItem } from '@material-ui/core';
import TextInput from 'components/TextInput/TextInput';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { orderBy } from 'lodash-es';

export const EmployerAllowancesTypeSelect = ({
  selectedValue,
  handleChange,
  disabled,
}) => {
  const { t } = useTranslation('common');

  const salaryTypeOptions = {
    MEAL_ALLOWANCE: {
      salaryName: t('report.salaries.meal_allowance'),
      salaryType: 'MEAL_ALLOWANCE',
    },
    FULL_DAILY_ALLOWANCE: {
      salaryName: t('report.salaries.full_daily_allowance'),
      salaryType: 'FULL_DAILY_ALLOWANCE',
    },
    DAILY_ALLOWANCE_HALF_DAY: {
      salaryName: t('report.salaries.daily_allowance_half_day'),
      salaryType: 'DAILY_ALLOWANCE_HALF_DAY',
    },
    KILOMETER_ALLOWANCE: {
      salaryName: t('report.salaries.kilometer_allowance'),
      salaryType: 'KILOMETER_ALLOWANCE',
    },
    TRAVEL_EXPENSE_COMPENSATION: {
      salaryName: t('report.salaries.travel_expense_compensation'),
      salaryType: 'TRAVEL_EXPENSE_COMPENSATION',
    },
    TAXABLE_REIMBURSEMENT_OF_EXPENSES: {
      salaryName: t('report.salaries.taxable_reimbursement_of_expenses'),
      salaryType: 'TAXABLE_REIMBURSEMENT_OF_EXPENSES',
    },
    WORKING_HOUR_REDUCTION_COMPENSATION: {
      salaryName: t('report.salaries.working_hour_reduction_compensation'),
      salaryType: 'WORKING_HOUR_REDUCTION_COMPENSATION',
    },
    TRAVEL_HOUR: {
      salaryName: t('report.salaries.travel_hour'),
      salaryType: 'TRAVEL_HOUR',
    },
    ADDITIONAL_WORK_HOUR: {
      salaryName: t('report.salaries.additional_work_hour'),
      salaryType: 'ADDITIONAL_WORK_HOUR',
    },
    CONTRACT_PAY: {
      salaryName: t('report.salaries.contract_pay'),
      salaryType: 'CONTRACT_PAY',
    },
    CONTRACT_WORK_HOUR: {
      salaryName: t('report.salaries.contract_work_hour'),
      salaryType: 'CONTRACT_WORK_HOUR',
    },
    NATIONAL_HOLIDAY_COMPENSATION: {
      salaryName: t('report.salaries.national_holiday_compensation'),
      salaryType: 'NATIONAL_HOLIDAY_COMPENSATION',
    },
    SUNDAY_WORK_COMPENSATION: {
      salaryName: t('report.salaries.sunday_work_compensation'),
      salaryType: 'SUNDAY_WORK_COMPENSATION',
    },
    CHILD_CARE_LEAVE: {
      salaryName: t('report.salaries.child_care_leave'),
      salaryType: 'CHILD_CARE_LEAVE',
    },
    MILITARY_REFRESHER_WAGE: {
      salaryName: t('report.salaries.military_refresher_wage'),
      salaryType: 'MILITARY_REFRESHER_WAGE',
    },
    MILITARY_SERVICE: {
      salaryName: t('report.salaries.military_service'),
      salaryType: 'MILITARY_SERVICE',
    },
    PARENTAL_LEAVE: {
      salaryName: t('report.salaries.parental_leave'),
      salaryType: 'PARENTAL_LEAVE',
    },
    HOLIDAY_BONUS_LEAVE: {
      salaryName: t('report.salaries.holiday_bonus_leave'),
      salaryType: 'HOLIDAY_BONUS_LEAVE',
    },
    STRIKE: {
      salaryName: t('report.salaries.strike'),
      salaryType: 'STRIKE',
    },
    TEMPORARY_LAY_OFF: {
      salaryName: t('report.salaries.temporary_lay_off'),
      salaryType: 'TEMPORARY_LAY_OFF',
    },
    STUDY_LEAVE: {
      salaryName: t('report.salaries.study_leave'),
      salaryType: 'STUDY_LEAVE',
    },
    INJURY_LEAVE: {
      salaryName: t('report.salaries.injury_leave'),
      salaryType: 'INJURY_LEAVE',
    },
    TEMPORARY_CHILD_CARE_LEAVE: {
      salaryName: t('report.salaries.temporary_child_care_leave'),
      salaryType: 'TEMPORARY_CHILD_CARE_LEAVE',
    },
    OTHER_PAID_LEAVE: {
      salaryName: t('report.salaries.other_paid_leave'),
      salaryType: 'OTHER_PAID_LEAVE',
    },
    OTHER_UNPAID_LEAVE: {
      salaryName: t('report.salaries.other_unpaid_leave'),
      salaryType: 'OTHER_UNPAID_LEAVE',
    },
    OVERTIME_LEAVE: {
      salaryName: t('report.salaries.overtime_leave'),
      salaryType: 'OVERTIME_LEAVE',
    },
    SALARY_HOUR: {
      salaryName: t('report.salaries.salary_hour'),
      salaryType: 'WORK_SALARY_HOURLY',
    },
    SALARY_MONTH: {
      salaryName: t('report.salaries.salary_month'),
      salaryType: 'WORK_SALARY_MONTHLY',
    },
    HOLIDAY_PAY: {
      salaryName: t('report.salaries.holiday_pay'),
      salaryType: 'HOLIDAY_PAY',
    },
    HOLIDAY_UNPAID: {
      salaryName: t('report.salaries.holiday_unpaid'),
      salaryType: 'HOLIDAY_UNPAID',
    },
    SICK_LEAVE: {
      salaryName: t('report.salaries.sick_leave'),
      salaryType: 'SICK_LEAVE',
    },
    WORKING_HOUR_REDUCTION_LEAVE: {
      salaryName: t('report.salaries.working_hour_reduction_leave'),
      salaryType: 'WORKING_HOUR_REDUCTION_LEAVE',
    },
    PUBLIC_HOLIDAY_LEAVE: {
      salaryName: t('report.salaries.public_holiday_leave'),
      salaryType: 'PUBLIC_HOLIDAY_LEAVE',
    },
  };

  return (
    <TextInput
      displayEmpty
      fullWidth
      id="employer-allowance-type-select"
      label={'Tyyppi' + '*'}
      onChange={(e) => handleChange(e.target.value, 'salaryType')}
      select
      shrink
      value={selectedValue || ''}
      disabled={disabled}
    >
      {orderBy(Object.values(salaryTypeOptions), 'salaryName', 'asc').map(
        (option, index) => (
          <MenuItem key={index} value={option.salaryType}>
            {option.salaryName}
          </MenuItem>
        )
      )}
    </TextInput>
  );
};
